import { storeToRefs } from 'pinia'
import { useAppSettingsStore } from '@/stores/appSettings'
import { defaultSettings } from '@/config/defaults'

/**
 * Composable для роботи з налаштуваннями додатку
 * Обгортка над useAppSettingsStore
 */
export function useAppSettings() {
  const store = useAppSettingsStore()

  const {
    settings,
    loading,
    error,
    isInitialized,
    hasError,
    appVersion,
    appLanguage,
    appTheme,
  } = storeToRefs(store)

  return {
    // State
    settings,
    loading,
    error,
    isInitialized,

    // Computed
    hasError,
    appVersion,
    appLanguage,
    appTheme,

    // Methods
    loadSettings: store.loadSettings,
    updateSettings: store.updateSettings,
    resetSettings: store.resetSettings,

    // Constants
    defaultSettings,
  }
}
